module.exports = __webpack_public_path__ + "img/sardines.74b9a46d.png";